import { IsArray, IsDefined, IsIn } from 'class-validator';
import { UserRole } from '../../keycloak/user-role-representation.dto';

export class UserRoleDto {
  @IsDefined()
  @IsArray()
  @IsIn(Object.values(UserRole), { each: true })
  roles!: UserRole[];
}
